module.exports = __webpack_public_path__ + "img/search-icon.fedd9527.svg";